// react
import React from "react";
// routing
import { useLocation } from "react-router-dom";
// base layout
import Client from "../base/client.tsx";
import PhotoGrapher from "../base/photographer.tsx";
import AdminBase from "../base/dashboard.tsx";
import AgentBase from "../base/agent.tsx";
// link
import { PhotographerRoutes } from "../../features/routes/photographerRoutes.tsx";
import { routes } from "../../features/routes/route.tsx";
import { AgentRoutes } from "../../features/routes/agentRoutes.tsx";
// address
import { getAllAddresses } from "../../features/address/address.tsx";

const Router = () => {
    const location = useLocation();
    // middlewheres
    const currentPath = decodeURIComponent(location.pathname);
    const photographerRoutes = getAllAddresses(PhotographerRoutes.photographer);
    const isPhotographerRoute = photographerRoutes.includes(currentPath);
    const clientRoutes = getAllAddresses(routes.client);
    const pagesRoutes = getAllAddresses(routes.pages)
    const isClientRoute = clientRoutes.includes(currentPath);
    const isPagesRoutes = pagesRoutes.includes(currentPath);
    const agentRoutes = getAllAddresses(AgentRoutes.agent);
    const isAgentRoute = agentRoutes.includes(currentPath);
    const is404 = location.pathname === '/404';
    return (
        <>
            {!is404 ? (
                <>
                    {isPhotographerRoute ?
                        (
                            <>
                                <PhotoGrapher />
                            </>
                        )
                        : isClientRoute || isPagesRoutes ?
                            (
                                <>
                                    <Client />
                                </>
                            )
                            : isAgentRoute ?
                                (
                                    <>
                                        <AgentBase />
                                    </>
                                )
                                :
                                (
                                    <>
                                        <AdminBase />
                                    </>
                                )
                    }
                </>
            ) : null}
        </>
    )
}

export default Router;